<template>
  <el-dialog
    title="商品配置"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="handleClosed">
    <div class="product-transfer-wrap">
      <el-transfer
        v-model="ruleForm.multipleSelection"
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入商品名称"
        :titles="['未应用', '已应用']"
        :data="ruleForm.list"
        :props="{
          key: 'exchangeGoodsId',
          label: 'goodsName',
        }"
      ></el-transfer>
    </div>
    <div slot="footer">
      <el-button
        type="primary"
        @click="addItem">更新</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ProductModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        tagScanSceneId: null,
        list: [],
        multipleSelection: []
      },
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 1000
      },
      product: {}
    }
  },
  methods: {
    filterMethod(query, item) {
      return item.goodsName.indexOf(query) > -1
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm = {
        tagScanSceneId: null,
        list: [],
        multipleSelection: []
      }
      this.product = {}
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('goods/getgoodslist', {
        payload: {
          ...this.config
        },
        success: (res) => {
          this.loading = false
          this.ruleForm.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.product = row
      this.ruleForm.tagScanSceneId = row.tagScanSceneId || null
      this.ruleForm.multipleSelection = (row.products || []).map(i => i.goodsId)
      this.toggleModal(true)
      this.$nextTick(() => {
        this.fetchList()
      })
    },
    addItem() {
      const result = this.ruleForm.multipleSelection
      if (result.length === 0) {
        this.$message.error('请选择商品')
        return
      }
      this.loading = true
      this.$store.dispatch('gateway/settagscansceneproducts', {
        payload: {
          tagScanSceneId: this.ruleForm.tagScanSceneId,
          goodsIds: result
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.product-transfer-wrap {
  .el-transfer {
    height: 400px;

    .el-transfer-panel {
      width: 300px;
      height: 100%;

      .el-transfer-panel__body {
        height: calc(100% - 40px);

        .el-transfer-panel__list {
          height: calc(100% - 62px);
        }
      }
    }
  }
}
</style>
